'use client';

import React, { useEffect, useRef, useState } from "react";
import debounce from 'lodash/debounce';

import { Tabs } from 'antd';
export type tabType={
	key:string,
	label:string,
	children:null
}
type ctabObj={
	tabList:tabType[]
}

const ClientTabs: React.FC<ctabObj> = ({ tabList }) => {
	const handleTabClick = (key: string) => {
		const element = document.getElementById(key);
		if (element) {
			element.scrollIntoView({ behavior: 'smooth' });
		}
	};
	const [isFixed, setIsFixed] = useState(false);
	const elementRef = useRef<HTMLDivElement>(null);
	const [initialTop, setInitialTop] = useState<number | null>(null);

	useEffect(() => {
		// 获取元素最初的 offsetTop
		if (elementRef.current && initialTop === null) {
			setInitialTop(elementRef.current.offsetTop);
		}
		const handleScroll =debounce(() => {
			if (initialTop !== null) {
				const scrollTop = window.scrollY;
				if (scrollTop + 105 >= initialTop) {
					setIsFixed(true);
				} else {
					setIsFixed(false);
				}
			}
		})

		window.addEventListener("scroll", handleScroll);

		// Cleanup listener on component unmount
		return () => {
			window.removeEventListener("scroll", handleScroll);
		};
	}, [initialTop]);



	return (
				<div className={`w-full z-50 bg-white  ${isFixed ? 'fixed top-[105px] left-0 ' : 'static '}`} ref={elementRef}>
			<Tabs
				centered
				indicator={{ size: (origin) => origin - 20, align: 'center' }}
				defaultActiveKey="Introduction"
				onTabClick={handleTabClick}
				items={tabList}
			/>
		</div>
	);
};

export default ClientTabs;
